import { config } from '@/forms/config';
import type {
  FormConditionalValidation,
  FormField,
  FormInitialValues,
  FormValidations,
  SingleFormField,
} from '@/forms/typings';
import { generateValidations } from '@/forms/utils/generateValidations';

import type { FormFieldModuleContext } from '../registry/field-module.types';

export function buildSingleFieldInitialState(
  field: FormField,
  values: FormInitialValues,
  validations: FormValidations,
  conditions: FormConditionalValidation[] | undefined,
  _ctx: FormFieldModuleContext,
): { initialValues: FormInitialValues; validationFields: FormValidations } {
  void _ctx;
  const initialValues: FormInitialValues = { ...values };
  const validationFields: FormValidations = { ...validations };

  const single = field as SingleFormField;

  if (single.notApplicableField) {
    initialValues[single.notApplicableField.fieldId] =
      single.notApplicableField.value;
  }

  initialValues[single.fieldId] = single.value;

  let combinedConditions = conditions;
  if (single.notApplicableField) {
    const shouldValidateFieldId = `${single.fieldId}${config.shouldValidateFieldSuffix}`;

    initialValues[shouldValidateFieldId] = !single.notApplicableField.value;

    combinedConditions = [
      {
        type: 'should-validate',
        relatedFieldId: shouldValidateFieldId,
      },
    ];

    if (conditions) {
      combinedConditions.push(...conditions);
    }
  }

  const schema = generateValidations(single, combinedConditions);

  if (schema) {
    validationFields[single.fieldId] = schema;
  }

  return { initialValues, validationFields };
}
